module.exports = __webpack_public_path__ + "changelog-1-8985bdd8fa91ac7942d0eee80d0f8f7c.webp";